import React from "react";
import Slider from "react-slick";
const HomeSlider = () => {
  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    adaptiveHeight: true,
  };
  return (
    <>
      <div className="slider-sec">
        <Slider {...settings}>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/sld2_New.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
          </div>
          <div>
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider18.jpg"
            className="d-block w-100"
            alt="The Air Force School"
          />
        </div>
                    <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider14.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
          </div>
                              <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider15.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
          </div>
                              <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider16.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
          </div>
                              <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider17.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
          </div>

         {/*<div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider1.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span>2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider2.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider3.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider4.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider5.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider6.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider7.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider8.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider9.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider10.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider11.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider12.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/slider13.jpg"
              className="d-block w-100"
              alt="The Air Force School"
            />
            <div className="slider-info">
              <h4>
                {" "}
                Raising Day <span> 2025 </span>{" "}
              </h4>
            </div>
  </div>*/}
        </Slider>
        <div className="thought">
          <div>
            <div className="thoughtimg">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/though.png"
                className="img-fluid"
                alt="The Air Force School"
              />
            </div>
            <h4>
              Learn from Yesterday, Live for Today, hope for tomorrow{" "}
              <span> Albert Einstein </span>{" "}
            </h4>
          </div>
        </div>

        <div className="mission">
          <div className="missionimg">
            {" "}
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/mision.png"
              className="img-fluid"
              alt="The Air Force School"
            />
            <div className="missiondesc">
              {" "}
              <p>
                “to develop our students into responsible, harmonious and
                integrated individuals through ever evolving curricular and
                co-curricular activities”
              </p>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeSlider;
